import axios from 'axios'
import { encodeGetParams, strToRegex } from '../utils/moxios.util.js'

export class Moxios {
	// _mocks = {}

	constructor() {
		axios.interceptors.request.use(this._redirectRequestToMock.bind(this))
		this._mocks = {}
	}

	mock(append) {
		for (const k in append) {
			let m = append[k]
			if (m === false) continue

			m = {}

			m.name = k
			m.url = k.split(' ')[1]

			if (!m.reUrl) m.reUrl = strToRegex(m.url)

			if (!m.matchMethod) m.matchMethod = k.split(' ')[0].toLowerCase()

			this._mocks[k] = m
		}
	}

	_redirectRequestToMock(config) {
		return new Promise((resolve) => {
			setTimeout(() => {
				if (localStorage['isMoxios'] == 'false') {
					resolve(config)
				}
				// const useMock = import.meta.env.VITE_APP_MOCKS == 'true'

				// if (useMock) {
				// 	resolve(config)
				// 	return
				// }

				const url = config.url.replace(/https?:\/\/[^/?]+/, '')

				let mocked
				for (const k in this._mocks) {
					const m = this._mocks[k]

					if (config.method == m.matchMethod && url.match(m.reUrl)) {
						mocked = m
						break
					}
				}

				if (mocked) {
					if (!mocked.fname) import.meta.env.VUE_APP_PLATFORM ? (mocked.fname = `/mock/${import.meta.env.VUE_APP_PLATFORM}/${mocked.url}.${config.method.toUpperCase()}.json`) : (mocked.fname = `/mock/${mocked.url}.${config.method.toUpperCase()}.json`)

					const c = {
						method: 'get',
						url: window.location.origin + mocked.fname + '?___MOCK___&' + encodeGetParams(config.data || {})
					}

					console.log(c)

					config = { ...config, ...c }
				}
				resolve(config)
			}, 500) // Oneskorí o 500 ms
		})
	}
}
